<template>
  <div>
    <label class="container">
      <input type="checkbox" :checked="checked" @change="update($event)" :disabled="disabled" />
      <span
        class="checkmark"
        onclick="if (this.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute('class') === 'ivu-radio-group ivu-radio-group-default ivu-radio-default'){this.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('input').click();}"
        :style="{
          backgroundColor: color,
          '--markcolor': disabled ? '#999' : dark ? '#fff' : '#111'
        }"
      ></span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      default: "#2196f3"
    },
    checked: {
      default: false
    },
    name: {},
    disabled: {
      default: false
    }
  },
  computed: {
    dark() {
      let color = this.color;
      // Check the format of the color, HEX or RGB?
      let r, g, b;
      if (color.match(/^rgb/)) {
        // If HEX --> store the red, green, blue values in separate variables
        color = color.match(
          /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
        );

        r = color[1];
        g = color[2];
        b = color[3];
      } else {
        // If RGB --> Convert it to HEX: http://gist.github.com/983661
        color = +(
          "0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&")
        );

        r = color >> 16;
        g = (color >> 8) & 255;
        b = color & 255;
      }

      // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
      const hsp = Math.sqrt(
        0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b)
      );

      // Using the HSP value, determine whether the color is light or dark
      if (hsp > 127.5) {
        return false;
      } else {
        return true;
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    update(e) {
      this.$emit("on-change", e.target.checked, this.name);
    }
  }
};
</script>

<style>
.container {
  display: inline-block;
  position: relative;
  height: 25px;
  width: 25px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  box-shadow: 1px 1px 2px #000;
  border-radius: 20% 20% 20% 20%;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  border-radius: 20% 20% 20% 20%;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 10px;
  top: 6px;
  width: 5px;
  height: 10px;
  border: solid var(--markcolor);
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
